import request from '@/utils/request'
//招聘信息
export const getRecruitList = (data) => request.post('/official/recruit/page',data)
